

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "src/@/components/ui/alert"
import Iconify from "src/components/Iconify"

export function AlertInfo({ title, description, variant }) {
  return (
    <Alert className="border-blue-100 bg-blue-50 flex items-center" >
      <Iconify
        icon="material-symbols:info-outline"
        className="text-blue-500"
      />
      <div className="flex flex-col gap-1">
        {
          title && (
            <AlertTitle>
              {title}
            </AlertTitle>
          )
        }

        <AlertDescription>
          {description}
        </AlertDescription>
      </div>

    </Alert>
  )
}